/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { EnrollmentScheduleDto } from '../models/enrollment-schedule-dto';
import { scheduleLogControllerCreate } from '../fn/schedule-log/schedule-log-controller-create';
import { ScheduleLogControllerCreate$Params } from '../fn/schedule-log/schedule-log-controller-create';
import { scheduleLogControllerFindByEnrollmentScheduleId } from '../fn/schedule-log/schedule-log-controller-find-by-enrollment-schedule-id';
import { ScheduleLogControllerFindByEnrollmentScheduleId$Params } from '../fn/schedule-log/schedule-log-controller-find-by-enrollment-schedule-id';
import { scheduleLogControllerFindByTicketIdWithMonth } from '../fn/schedule-log/schedule-log-controller-find-by-ticket-id-with-month';
import { ScheduleLogControllerFindByTicketIdWithMonth$Params } from '../fn/schedule-log/schedule-log-controller-find-by-ticket-id-with-month';
import { scheduleLogControllerSearch } from '../fn/schedule-log/schedule-log-controller-search';
import { ScheduleLogControllerSearch$Params } from '../fn/schedule-log/schedule-log-controller-search';
import { scheduleLogControllerUpdate } from '../fn/schedule-log/schedule-log-controller-update';
import { ScheduleLogControllerUpdate$Params } from '../fn/schedule-log/schedule-log-controller-update';
import { ScheduleLogWithMonthDto } from '../models/schedule-log-with-month-dto';

@Injectable({ providedIn: 'root' })
export class ScheduleLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `scheduleLogControllerSearch()` */
  static readonly ScheduleLogControllerSearchPath = '/api/schedule-log/search';

  /**
   * 회기일지 조회.
   *
   * 회기일지를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduleLogControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduleLogControllerSearch$Response(params: ScheduleLogControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EnrollmentScheduleDto>>> {
    return scheduleLogControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 회기일지 조회.
   *
   * 회기일지를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduleLogControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduleLogControllerSearch(params: ScheduleLogControllerSearch$Params, context?: HttpContext): Observable<Array<EnrollmentScheduleDto>> {
    return this.scheduleLogControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EnrollmentScheduleDto>>): Array<EnrollmentScheduleDto> => r.body)
    );
  }

  /** Path part for operation `scheduleLogControllerFindByTicketIdWithMonth()` */
  static readonly ScheduleLogControllerFindByTicketIdWithMonthPath = '/api/schedule-log/month';

  /**
   * 월별 회기일지 조회.
   *
   * 회기일지를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduleLogControllerFindByTicketIdWithMonth()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduleLogControllerFindByTicketIdWithMonth$Response(params: ScheduleLogControllerFindByTicketIdWithMonth$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ScheduleLogWithMonthDto>>> {
    return scheduleLogControllerFindByTicketIdWithMonth(this.http, this.rootUrl, params, context);
  }

  /**
   * 월별 회기일지 조회.
   *
   * 회기일지를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduleLogControllerFindByTicketIdWithMonth$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduleLogControllerFindByTicketIdWithMonth(params: ScheduleLogControllerFindByTicketIdWithMonth$Params, context?: HttpContext): Observable<Array<ScheduleLogWithMonthDto>> {
    return this.scheduleLogControllerFindByTicketIdWithMonth$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ScheduleLogWithMonthDto>>): Array<ScheduleLogWithMonthDto> => r.body)
    );
  }

  /** Path part for operation `scheduleLogControllerFindByEnrollmentScheduleId()` */
  static readonly ScheduleLogControllerFindByEnrollmentScheduleIdPath = '/api/schedule-log/{id}';

  /**
   * 회기일지 조회.
   *
   * 회기일지를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduleLogControllerFindByEnrollmentScheduleId()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduleLogControllerFindByEnrollmentScheduleId$Response(params: ScheduleLogControllerFindByEnrollmentScheduleId$Params, context?: HttpContext): Observable<StrictHttpResponse<EnrollmentScheduleDto>> {
    return scheduleLogControllerFindByEnrollmentScheduleId(this.http, this.rootUrl, params, context);
  }

  /**
   * 회기일지 조회.
   *
   * 회기일지를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduleLogControllerFindByEnrollmentScheduleId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduleLogControllerFindByEnrollmentScheduleId(params: ScheduleLogControllerFindByEnrollmentScheduleId$Params, context?: HttpContext): Observable<EnrollmentScheduleDto> {
    return this.scheduleLogControllerFindByEnrollmentScheduleId$Response(params, context).pipe(
      map((r: StrictHttpResponse<EnrollmentScheduleDto>): EnrollmentScheduleDto => r.body)
    );
  }

  /** Path part for operation `scheduleLogControllerUpdate()` */
  static readonly ScheduleLogControllerUpdatePath = '/api/schedule-log/{id}';

  /**
   * 회기일지 수정.
   *
   * 회기일지를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduleLogControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduleLogControllerUpdate$Response(params: ScheduleLogControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return scheduleLogControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 회기일지 수정.
   *
   * 회기일지를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduleLogControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduleLogControllerUpdate(params: ScheduleLogControllerUpdate$Params, context?: HttpContext): Observable<void> {
    return this.scheduleLogControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `scheduleLogControllerCreate()` */
  static readonly ScheduleLogControllerCreatePath = '/api/schedule-log';

  /**
   * 회기일지 작성.
   *
   * 회기일지를 작성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduleLogControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduleLogControllerCreate$Response(params: ScheduleLogControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return scheduleLogControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 회기일지 작성.
   *
   * 회기일지를 작성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduleLogControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduleLogControllerCreate(params: ScheduleLogControllerCreate$Params, context?: HttpContext): Observable<void> {
    return this.scheduleLogControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
